export function formatToLocalISO(dateInput, format) {
  const date = new Date(dateInput);
  const pad = (n) => String(n).padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  if (format === undefined)
    return `${hours}:${minutes}:${seconds} ${day}/${month}`;
  if (format === "hms")
    return `${hours}:${minutes}:${seconds}`;
  if (format === "dm")
    return `${day}/${month}`;
}
